// extracted by mini-css-extract-plugin
module.exports = {"deleteMachineHeaderContainer":"styles_deleteMachineHeaderContainer__18mAM","deleteMachineBodyContainer":"styles_deleteMachineBodyContainer__3NsJZ"};